<template>
  <el-row style="background-color: #E9EEF3; padding: 10px">
    <el-row :style="{'background-color': 'white','height': pageHeight}">
      <el-col class="filter_framework">
        <label>问题反馈时间</label>
        <el-date-picker v-model="dateRange" type="daterange" unlink-panels :clearable="false" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                        @change="changeFilteringForm()"
                        :default-time="['00:00:00', '23:59:59']">>
        </el-date-picker>
      </el-col>
      <el-col style="padding: 10px">
        <el-table :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="headerClass">
          <el-table-column prop="" label="创建时间" align="center" width="200px">
            <template slot-scope="scope">
              {{ scope.row.updatedTime | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" align="center" width="200px"></el-table-column>
          <el-table-column prop="content" label="反馈内容" align="center"></el-table-column>
        </el-table>
      </el-col>
      <el-col >
        <el-pagination
            @size-change="handlePageSizeChange"
            @current-change="handleCurrentPageChange"
            :current-page="pageInfo.current"
            :page-sizes="[10, 50, 100]"
            :page-size="pageInfo.size"
            layout="sizes, prev, pager, next, total"
            :total="pageInfo.total">
        </el-pagination>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "ProblemFeedBack",
  filters: {
    dateFormat: function (data) {
      return data.slice(0,10) + ' ' + data.slice(11,19);
    },
  },
  data() {
    return {
      GLOBAL,
      pageHeight: '',
      //日期选择器快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90 * 4);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateRange: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
      filteringForm: {
        startTime: (new Date()).getTime() - 3600 * 1000 * 24 * 7,
        endTime: new Date().getTime(),
      }, //当前筛选框值
      tableData: [],
      // 分页信息
      pageInfo: {
        // 分页信息
        current: 1,
        size: 10,
        total: 0,
      },
    }
  },
  mounted() {
    this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    window.onresize = function () {
      this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    };
  },
  watch: {
    filteringForm: {
      deep: true,
      handler: function () {
        // this.$emit("changeData", this.filteringForm);
        this.getFeedbackList();
      },
    },
  },
  created() {
    this.getFeedbackList();
  },
  methods: {
    // 统计项筛选框变化触发
    async changeFilteringForm() {
      this.ensembleFilteringForm();
    },
    // 组装FilteringForm
    ensembleFilteringForm() {
      // 对时间进行处理
      let date = this.dateRange.map((item) => item.getTime());
      this.filteringForm.startTime = date[0];
      this.filteringForm.endTime = date[1];
    },
    getFeedbackList() {
      this.$store.dispatch("Statistics/getFeedbackList", {
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size,
        startTime: this.filteringForm.startTime,
        endTine: this.filteringForm.endTime,
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //表头样式
    headerClass() {
      return 'background: #EBEEF5'
    },
    // 分页切换当前页码时调用
    handleCurrentPageChange(currentPage) {
      this.pageInfo.current = currentPage;
      this.getFeedbackList();
    },
    // 分页尺寸更换时候调用
    handlePageSizeChange(pageSize) {
      this.pageInfo.current = 1;
      this.pageInfo.size = pageSize;
      this.getFeedbackList();
    },
  }
}
</script>

<style scoped>
.filter_framework {
  padding: 20px;
  text-align: left;
  border-bottom: #E9EEF3 solid 1px;
}

label {
  font-size: 16px;
  padding-left: 0;
  padding-right: 20px;
}
</style>
